/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Split {
  /**
   * Split a string by a key
   *
   * @public
   * @function f1.split
   * @param by the sub-string to split by
   * @param s any string
   * @example
   *
   * ```ts
   * f1.split(',', 'walk,park') === ['walk', 'park']
   * ```
   */
  (by: string, s: string): string[];
  (by: string): (s: string) => string[];
}

/**
 * @see Split
 */
export default (by: string, s: string) => {
  return s.split(by);
};
